/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Mark_RentedInputs */

const cs_property_mark_rented = /** @type {(inputs: Property_Mark_RentedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako pronajaté`)
};

const en_property_mark_rented = /** @type {(inputs: Property_Mark_RentedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as rented`)
};

/**
* | output |
* | --- |
* | "Mark as rented" |
*
* @param {Property_Mark_RentedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_mark_rented = /** @type {((inputs?: Property_Mark_RentedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Mark_RentedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_mark_rented(inputs)
	return cs_property_mark_rented(inputs)
});